var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50%","margin":"auto"}},[(_vm.value)?_c('div',{staticClass:"slide-bottom"},[_c('EspError',{attrs:{"icon":"mdi-close","iconColor":_vm.iconColor,"text":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }